<div *ngIf="headline || anchor" class="section-headline-wrapper {{ theme }}">
  <div *ngIf="anchor" [mbScrollSpy]="anchor"></div>
  <div *ngIf="headline" class="section-headline-container" [ngClass]="containerClass">
    <div>
      <span class="section-headline-dash"></span>
      <h2>{{ headline }}</h2>
    </div>
    <ng-content></ng-content>
  </div>
</div>
